import React, { useEffect, useRef, useState  } from 'react';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/HR_Managment/Leave_Type/AddLeaveType'; 
import Edit from '../../../../modal/Settings/HR_Managment/Leave_Type/EditLeaveType';
import EditLeaveType from '../../../../modal/Settings/HR_Managment/Leave_Type/EditLeaveType';
import axios from 'axios'; // new


const Leave_Type = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const tableRef = useRef(null);
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");
    const handleModalToggle = () => {
        setModalType("Add");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };
    const handleModalToggle_Edit = () => {
        setModalType("Edit");  // Set the modal type to "Add"
        setOpen(true);
    };

    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(10); //pagination
    const [leaveType, setleaveType] = useState([]); //new list

    const [hasFetched, setHasFetched] = useState(false); 
        const softRefresh = () => {
            setHasFetched(false);
            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            fetchLeaveType();
        }
     
       
    const fetchLeaveType = async (pageNumber = 1, perPageCount = 25, search = '') => {
                try {
                    const response = await axios.get(`${baseURL}/manage-leavetype`, {
                        params: {
                            page: pageNumber,
                            per_page: perPageCount,
                            search: search,
                        }
                    }); 
    
                    const data = response.data;
                    setleaveType(data.data || []); 
                    setHasFetched(true);
                    // Optional: store pagination data
                    // setPagination(data.pagination);
    
                } catch (error) {
                    console.error('Error fetching leave type:', error);
                }
            };
    
    useEffect(() => {
        fetchLeaveType(page, perPage, searchTerm);
    }, [page, searchTerm, perPage]);

 
            const DeleteModal = (id, name, fetchLeaveType) => {
                swal.fire({
                    html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose one Item Sub Category
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <p class="text-center"><b>${name}</b></p>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true,
                    customClass: {
                        title: 'fs-6',
                        cancelButton: 'btn btn-sm btn-secondary',
                        confirmButton: 'btn btn-sm btn-danger',
                        htmlContainer: 'text-left'
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        // 🔥 Call DELETE API
                        axios.delete(`${baseURL}/manage-leavetype/${id}`)
                            .then(() => {
                                swal.fire({
                                    title: 'leave type Deleted!',
                                    text: `${name} has been marked as deleted.`,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    customClass: {
                                        title: 'fs-6',
                                        confirmButton: 'btn btn-sm btn-primary',
                                    },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                }).then(() => {
                                    // fetchCategories(); // ✅ Silently refresh list
                                    // window.location.reload();
                                    softRefresh();
                                    toast.success("Leave Type Deleted Successfully!");
                                });
                            })
                            .catch((error) => {
                                console.error("Delete failed:", error);
                                toast.error("Leave Type Deletion Failed");
                                // swal.fire({
                                //     title: 'Error!',
                                //     text: 'Something went wrong while deleting.',
                                //     icon: 'error',
                                //     confirmButtonText: 'OK',
                                //     customClass: {
                                //         title: 'fs-6',
                                //         confirmButton: 'btn btn-sm btn-primary',
                                //     },
                                // });
                            });
                    }
                });
            };


    const handleStatusChange = (leaveTypeId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/manage-leavetype/status/${leaveTypeId}`, { status: newStatus })
            .then(() => {
                fetchLeaveType();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.error("Error updating status:", error);
                toast.error("status Updation Failed!");
            });
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    //   "aaSorting": [],
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);


    const handleAddSuccess = () => {
        console.log("Add success called!");
        toast.success("Leave Type added successfully!");
        setOpen(false);
        softRefresh();
    };


        const [editModalShow, setEditModalShow] = useState(false);
        const [currentItemId, setCurrentDepartmentId] = useState(null);

        const handleModalDepartment_Edit = (id) => {
        setEditModalShow(true);
        setCurrentDepartmentId(id);
    };
 
    


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Leave Type</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                    </ol>
                </div>
                <Button
                    className="btn btn-primary btn-sm"
                    onClick={handleModalToggle}
                >
                    <span className="me-2">
                        <i className="fa-solid fa-plus fs-8"></i>
                    </span>
                    <span>Add Leave Type</span>
                </Button>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} />
                )}
            </div>
            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                  </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                           
                            <th className='min-w-150px'>Leave Type</th>
                            <th className='min-w-300px'>Description</th>
                            <th className='min-w-100px'>Status</th>
                            {/* <th className='min-w-100px'>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">

                        {Array.isArray(leaveType) && leaveType.length > 0 ? (
                        leaveType.map((leave) => (
                            <tr key={leave.sno}>
                          
                                <td>
                                    <label className='text-black font-w400 fs-7'>{leave.leavetype_name}</label>
                                </td>
                                <td>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' >
                                        <span className='fs-8 text-white fw-semibold'>{leave.description
                                              ? leave.description
                                              : "No description available."}</span></Tooltip>} >
                                        <div className='text-truncate mw-400px text-black font-w400 fs-7'>
                                            {leave.description
                                              ? leave.description
                                              : "No description available."}</div>
                                    </OverlayTrigger>
                                </td>
                                <td>
                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                      <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        role="switch"
                                        checked={leave.status == 0}
                                        onChange={() =>
                                          handleStatusChange(
                                            leave.sno,
                                            leave.status
                                          )
                                        }
                                      />
                                    </div>
                                </td>
                            </tr>
                              ))
                        ) : hasFetched ? (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-2">
                              No data available
                            </td>
                          </tr>
                        ) : null}
                    </tbody>
                </table>
                
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {leaveType.length > 0 && (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + leaveType.length} of {totalPages * perPage - (perPage - leaveType.length)} entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                  </div>
 
                  
                    <EditLeaveType
                    show={editModalShow}
                    onClose={() => setEditModalShow(false)}
                    id={currentItemId}
                    onUpdated={fetchLeaveType}
                    />
            </div>
        </>
    )


}
export default Leave_Type;